<template>
    <li class="widget__list__option">
        <base-button
            class="widget__list__option__button background--transparent"
            type="button"
            :customClass="true"
            :hasHover="false"
            @click="settings.action"
            v-html="$t(`global.${settings.label}`)"
        />
    </li>
</template>

<script>
export default {
    components: {
        BaseButton: () => import( /* webpackChunkName: 'BaseButton' */ '@/components/bundles/buttons/BaseButton' )
    },
    props: {
        settings: {
            type: Object,
            default: () => ({ action: null, label: '' })
        }
    },
    setup () {
        return {};
    }
};
</script>